<script>
    import vClickOutside from "v-click-outside";

    export default {
        directives: {
            clickOutside: vClickOutside.directive,
        },
        data() {
            return {
                isOpen: false,
                selected: null
            }
        },
        props: {
            type: String,
            items: Array,
            userSelect: String,
            name: String,
            handleSelect: Function,
            placeholder: String
        },
        methods: {
            toggleModal() {
                this.isOpen = !this.isOpen;
            },
            modalClose() {
                this.isOpen = false;
            },
            onSelect(e) {
                if (this.$props.type === 'objArray') {
                    const change = {key: this.name, value: e.target.id}
                    this.$props.handleSelect(change);
                    this.modalClose;
                } else {
                    this.$props.handleSelect(e);
                    this.modalClose;
                }
            }
        },
    }
</script>

<template>
    <div
    v-click-outside="modalClose"
    class="dropdownWrapper"
    @click="toggleModal"
    >
    <div class="dropdownChoosen">
    <div class="leftWrapper">
        <p class="chosenText">
            {{ userSelect || placeholder }}
        </p>
    </div>
    <svg class="dropSvg" :class="{isOpen: isOpen}" width="14" height="8">
        <use href="../../assets/icons/arrow-down.svg#arrow-down"></use>
    </svg>
    </div>
    <ul class="dropList" :class="{ isOpen: isOpen }">
        <li v-if="type === 'objArray'" v-for="item in items" class="dropListItem">
            <button :id="item[0]" @click="onSelect" class="dropListItemBtn">
                {{ item[1] }}
            </button>
        </li>
        <li v-if="type === 'array'" v-for="item of items" class="dropListItem">
            <button :name="name" @click="onSelect" :value="item" class="dropListItemBtn">
                {{ item }}
            </button>
        </li>
    </ul>
    </div>
</template>

<style lang="scss" scoped>
.dropdownWrapper {
    font-family: 'Inter', sans-serif;
    position: relative;
    max-width: 312px;
    padding: 12px 16px 12px 20px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    transition: all 150ms linear;

    &:focus-visible,
    &:hover {
        border-color: rgb(49, 130, 206);
        box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
    }
}
    
.dropdownChoosen {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
}

.leftWrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.imgWrapper {
    position: relative;
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 50%;
    overflow: hidden;
}

.chosenImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

svg.dropSvg {
    width: 14px;
    height: 8px;
    stroke: #3056d3;
    transition: all 150ms linear;

    &.isOpen {
    transform: rotate(180deg);
    }
}

.chosenText {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}
    
.dropList {
    font-family: 'Inter', sans-serif;
    display: none;
    position: absolute;
    z-index: 2;
    top: 101%;
    left: 0;
    list-style: none;
    background-color: white;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    margin: 0;
    padding: 12px 5px;

    &.isOpen {
    display: block;
    }
  }
  
.dropListItem {
    width: 100%;
    border-radius: 5px;
    padding: 0 15px;
    transition: all 150ms linear;
  
    &:hover,
    :focus-visible {
      background-color: #3056d3;
      color: white;
    }
  
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
  
  .dropListItemBtn {
    width: 100%;
    text-align: left;
    font-family: inherit;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: inherit;
    border: none;
    outline: none;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
  }
  
  .chosenText {
    margin: 0;
  }
  </style>